module.exports = __webpack_public_path__ + "img/Wray-Nicholson_House_17938-s002.55fc5091.jpg";